import { useMemo } from "react";
import { formatISO } from "date-fns";
import { DATE_RANGE_PRESETS_BY_ID } from "@helpers/date";
import { useAccountingTabContext } from "./useAccountingTab";

export function getDefaultStartDate() {
    return DATE_RANGE_PRESETS_BY_ID.this_year_to_date.getStart(new Date());
}

export function getDefaultEndDate() {
    return DATE_RANGE_PRESETS_BY_ID.this_year_to_date.getEnd(new Date());
}

export function useProfitLossInitialDates() {
    const accountingCtx = useAccountingTabContext();

    const dateStart = useMemo(
        () =>
            formatISO(
                accountingCtx?.filters?.startDate ?? getDefaultStartDate(),
                {
                    representation: "date",
                },
            ),
        [accountingCtx?.filters?.startDate],
    );
    const dateEnd = useMemo(
        () =>
            formatISO(accountingCtx?.filters?.endDate ?? getDefaultEndDate(), {
                representation: "date",
            }),
        [accountingCtx?.filters?.endDate],
    );

    return {
        dateStart,
        dateEnd,
    };
}
